import { Box, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import classes from "./ResendRow.module.css";

export interface ResendRowProps {
  /** `useCountdown().left` — үлдсэн секунд. */
  left: number;
  sending?: boolean;
  onResend: () => void;
}

const formatTimer = (s: number) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

/** «Код ирээгүй юу? · Дахин илгээх 0:42» мөр. Тоолуур дуустал товч идэвхгүй. */
export function ResendRow({ left, sending, onResend }: ResendRowProps) {
  const { t } = useTranslation("auth");
  return (
    <Box className={classes.root}>
      <Text span inherit>
        {t("forgot.noCode")}
      </Text>
      <Box component="button" type="button" className={classes.resend} disabled={left > 0 || sending} onClick={onResend}>
        {t("forgot.resend")}
        {left > 0 && (
          <>
            {" "}
            <Text span inherit className={classes.timer}>
              {formatTimer(left)}
            </Text>
          </>
        )}
      </Box>
    </Box>
  );
}
